import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var DrivingDirectionsSVG = function DrivingDirectionsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.42 14.6l-12-12a2 2 0 00-2.8 0l-12 12a2 2 0 000 2.8l12 12a2 2 0 002.8 0l12-12a2 2 0 000-2.8zm-7.6.87l-3.66 4.19a1 1 0 01-.74.34 1 1 0 01-.74-1.66l2-2.34H12v2a1 1 0 01-1 1 1 1 0 01-1-1v-2.61A1.39 1.39 0 0111.39 14h7.33l-2-2.34a1 1 0 01.08-1.41 1 1 0 011.4.09l3.66 4.19a.7.7 0 01-.04.94z"
  }));
};
DrivingDirectionsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DrivingDirectionsSVG);